import { executeGetRequest, FetchConfig } from '@api/client';
import { createFetchVersionPath } from '@routing/apiUrls';
import { FetchVersionResponse } from '@models/version/FetchVersion';

export const fetchVersion = async (config?: FetchConfig) => {
    const result = await executeGetRequest<FetchVersionResponse>(createFetchVersionPath(), config);
    return result.data;
};
